import closeIcon from '../../../images/icons/close.svg';

export default (function ($, Drupal) {
  /**
   * input instance for handling input focus and clear button
   * currently used for search input
   * @param {jQuery} $input test
   * @param {object} options options how to handle the input field
   */
  function input($input, options) {
    let $inputWrapper;
    let $clearButton;
    let showClearButton;
    const focusClass = 'form-item--focus';

    if ($input.length > 0) {
      $inputWrapper = $input.closest('.js-form-item');

      if (options.clearButton) {
        addClearButton();
        handleClearButton();

        $input.on('keyup', onChange);
        $input.on('input', onChange);
        $clearButton.on('click', clearInput);
      }

      $input.on('focusin', onFocus);
      $input.on('focusout', onBlur);
    }

    function onFocus() {
      $inputWrapper.addClass(focusClass);
    }

    function onBlur() {
      $inputWrapper.removeClass(focusClass);
    }

    function onChange() {
      handleClearButton();
    }

    /**
     * show clear button when input is filled
     * and hide when empty
     */
    function handleClearButton() {
      if (!showClearButton && $input.val().length > 0) {
        showClearButton = true;
        $clearButton.show();
      }

      if ($input.val() === '') {
        showClearButton = false;
        $clearButton.hide();
      }
    }

    function clearInput(event) {
      $input.val('');
      handleClearButton();
      event.preventDefault();
      // dispatch an event to the native element so that none Jquery can get it as well.
      $input[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    /**
     * insert clear button after input
     * clear text shows the X from icons
     */
    function addClearButton() {
      $clearButton = $input.parent().find('.form-input-clear');
      if ($clearButton.length > 0) {
        return;
      }
      $clearButton = $(
        `<button type='button' class='btn-icon form-input-clear'>${closeIcon}</button>`,
      );
      $input.after($clearButton);
    }
  }

  Drupal.behaviors.input = {
    attach: () => {
      $(once('veolia-form-input', 'input')).each(function () {
        const $input = $(this);
        const options = {};
        if ($input.hasClass('form-autocomplete')) {
          options.clearButton = true;
        }

        input($input, options);
      });
    },
  };
}(jQuery, Drupal, once));
